import { render, staticRenderFns } from "./MatchResult.vue?vue&type=template&id=58caf709&scoped=true"
import script from "./MatchResult.vue?vue&type=script&lang=js"
export * from "./MatchResult.vue?vue&type=script&lang=js"
import style0 from "./MatchResult.vue?vue&type=style&index=0&id=58caf709&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58caf709",
  null
  
)

export default component.exports